<template>
  <!-- 首頁导航 -->
  <div class="not_found">
    <!-- <img src="../../assets/img/common/404/404.png" alt=""> -->
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    goHome(){
      this.$router.go(0);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.not_found {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/img/common/404/404.jpg") no-repeat center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
